// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/.pnpm/css-loader@6.3.0_webpack@5.99.8/node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/.pnpm/css-loader@6.3.0_webpack@5.99.8/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".SimplePaperPodcast-cls1__d0634f2453c6be85e30f{/*!*/}.SimplePaperPodcast-cls2___8f171627a56237c39d5{padding:16px;display:flex;align-items:center;grid-gap:8px;gap:8px;color:#dc2626;font-size:14px}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"cls1": "SimplePaperPodcast-cls1__d0634f2453c6be85e30f",
	"cls2": "SimplePaperPodcast-cls2___8f171627a56237c39d5 SimplePaperPodcast-cls1__d0634f2453c6be85e30f"
};
export default ___CSS_LOADER_EXPORT___;
